const holidays = {
  holidays: 'Fériés',
  search_holiday: 'Rechercher un jour fériés',
  add_holiday: 'Nouveau jour férié',
  update_holiday: 'Fériés',
  modal_general: 'Général',
  modal_events: 'Événements',
  form: {
    occurrence: 'Occurrence',
    month: 'Mois',
    day: 'Jour',
    occurs: 'Se produit',
    year: 'An',
    duration_days: 'Durée Jours',
    hours: 'Les heures',
    minutes: 'Minutes',
  },
  table: {
    holiday: 'FÉRIÉS',
    state: 'ÉTAT',
    date: 'DATE',
    duration: 'DURÉE',
    is_yearly: 'EST ANNUEL',
    is_relative: 'EST UNE DATE RELATIVE',
    relative_week_day: 'JOUR DE SEMAINE RELATIF',
  },
};

export default holidays;
